import { render } from "./index.vue?vue&type=template&id=28d821e8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-28d821e8"

export default script